import React, { Component, Fragment, createRef } from "react";
import { connect } from "react-redux";
import { Field } from "react-final-form-html5-validation";
import { OnChange } from "react-final-form-listeners";
import * as actions from "../../actions";
import {
    isRequiredSelectionCheckbox,
    isRequiredQuestionSelectionAlt,
    isRequiredPhoneNumber,
    isRequiredText,
    numberValidator,
    isRequired,
} from "../helpers/Validation";
import { textField } from "../helpers/Form";

class Step2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            insuranceStatus: "null",
        };
    }

    prescriberPhoneTwo = createRef();
    prescriberPhoneThree = createRef();
    cardholderPhoneTwo = createRef();
    cardholderPhoneThree = createRef();

    componentDidMount() {
        const element = document.getElementById("step2");
        if (element) {
            const offset = 5;
            const topPosition =
                element.getBoundingClientRect().top + window.pageYOffset;

            window.scroll({
                top: topPosition - offset,
                left: 0,
                behavior: "smooth",
            });
        }
    }

    render() {
        const { currentStep } = this.props;
        const {
            insuranceStatus,
            prescriberPhoneOne,
            prescriberPhoneTwo,
            prescriberPhoneThree,
            cardholderPhoneOne,
            cardholderPhoneTwo,
            cardholderPhoneThree,
        } = this.props.questionOptions;

        return (
            <Fragment>
                <div className="row mobile-step-header" id="step2">
                    <div className="col-sm-2 col-2">
                        <span className="header-number">{currentStep}</span>
                    </div>
                    <div className="col-sm-10 col-10 pl-3">
                        <h3 className="euclid">INSURANCE INFORMATION</h3>
                        <div className="d-inline-block">
                            *
                            <i class="required-field-indication">
                                &nbsp;Indicates required field.
                            </i>
                        </div>
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>

                <div className="row spacer-medium" ref={this.toTop}>
                    &nbsp;
                </div>

                <div className="row">
                    <div className="col">
                        <div className="form-group">
                            <Field
                                name="insuranceStatus"
                                component="input"
                                defaultValue={insuranceStatus}
                                validate={isRequiredQuestionSelectionAlt}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label
                                            className={
                                                meta.error && meta.touched
                                                    ? "error"
                                                    : ""
                                            }
                                            htmlFor="state"
                                        >
                                            Insurance status*
                                        </label>
                                    </Fragment>
                                )}
                            </Field>
                            <div className="radio-field">
                                <Field
                                    name="insuranceStatus"
                                    type="radio"
                                    className=""
                                >
                                    {({ input, meta }) => {
                                        return (
                                            <Fragment>
                                                <input
                                                    className=""
                                                    id="insurance-yes"
                                                    name={input.name}
                                                    type="radio"
                                                    onClick={(event) =>
                                                        this.props.questionAnswer(
                                                            "insuranceStatus",
                                                            "yes"
                                                        )
                                                    }
                                                />
                                            </Fragment>
                                        );
                                    }}
                                </Field>
                                <label htmlFor="insurance-yes" className="">
                                    Patient has insurance
                                </label>
                            </div>
                            <div className="radio-field">
                                <Field
                                    name="insuranceStatus"
                                    type="radio"
                                    className=""
                                >
                                    {({ input, meta }) => {
                                        return (
                                            <Fragment>
                                                <input
                                                    className=""
                                                    id="insurance-no"
                                                    name={input.name}
                                                    type="radio"
                                                    onClick={(event) =>
                                                        this.props.questionAnswer(
                                                            "insuranceStatus",
                                                            "no"
                                                        )
                                                    }
                                                />
                                            </Fragment>
                                        );
                                    }}
                                </Field>
                                <label htmlFor="insurance-no" className="">
                                    Patient does not have insurance
                                </label>
                            </div>
                            <Field
                                name="insuranceStatus"
                                component="input"
                                defaultValue={insuranceStatus}
                                validate={isRequiredQuestionSelectionAlt}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            type="text"
                                            className="form-control full-width-input hidden-field"
                                            tabindex="-1"
                                        />
                                        {meta.error &&
                                            meta.touched &&
                                            meta.error}
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                </div>

                {insuranceStatus === "yes" && (
                    <Fragment>
                        <div className="row">
                            <div className="col ">
                                <div className="form-group">
                                    <Field
                                        name="prescriptionDrugPlan"
                                        label="Prescription drug plan*"
                                        placeholder=""
                                        component={textField}
                                        validate={isRequiredText}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm">
                                <Field
                                    name="idNumber"
                                    label="ID number*"
                                    component={textField}
                                    validate={isRequiredText}
                                />
                            </div>
                            <div className="col-sm">
                                <div
                                    className="form-group ins-phone-stack"
                                    style={{ right: "0px" }}
                                >
                                    <Field
                                        name="prescriberPhoneNumber"
                                        component="input"
                                        defaultValue={
                                            prescriberPhoneOne +
                                            prescriberPhoneTwo +
                                            prescriberPhoneThree
                                        }
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <label className="">
                                                    Phone number
                                                </label>
                                            </Fragment>
                                        )}
                                    </Field>
                                    <div className="phone-group">
                                        <Field
                                            name="prescriberPhoneOne"
                                            component="input"
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <input
                                                        {...input}
                                                        className="form-control inline-phone phone-area-code"
                                                        type="text"
                                                        maxLength="3"
                                                        placeholder="123"
                                                        inputMode="numeric"
                                                    />
                                                </Fragment>
                                            )}
                                        </Field>
                                        <OnChange name="prescriberPhoneOne">
                                            {(value, previous) => {
                                                if (numberValidator(value)) {
                                                    this.props.questionAnswer(
                                                        "prescriberPhoneOne",
                                                        value
                                                    );
                                                    if (value.length === 3) {
                                                        this.prescriberPhoneTwo.current.focus();
                                                    }
                                                }
                                            }}
                                        </OnChange>
                                        <Field
                                            name="prescriberPhoneTwo"
                                            component="input"
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <input
                                                        className="form-control inline-phone phone-prefix"
                                                        {...input}
                                                        type="text"
                                                        maxLength="3"
                                                        placeholder="456"
                                                        ref={
                                                            this
                                                                .prescriberPhoneTwo
                                                        }
                                                        inputMode="numeric"
                                                    />
                                                </Fragment>
                                            )}
                                        </Field>
                                        <OnChange name="prescriberPhoneTwo">
                                            {(value, previous) => {
                                                if (numberValidator(value)) {
                                                    this.props.questionAnswer(
                                                        "prescriberPhoneTwo",
                                                        value
                                                    );
                                                    if (value.length === 3) {
                                                        this.prescriberPhoneThree.current.focus();
                                                    }
                                                }
                                            }}
                                        </OnChange>
                                        <Field
                                            name="prescriberPhoneThree"
                                            component="input"
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <input
                                                        className="form-control inline-phone phone-line-number"
                                                        {...input}
                                                        type="text"
                                                        maxLength="4"
                                                        placeholder="7890"
                                                        ref={
                                                            this
                                                                .prescriberPhoneThree
                                                        }
                                                        inputMode="numeric"
                                                    />
                                                    {meta.error &&
                                                        meta.touched &&
                                                        meta.error}
                                                </Fragment>
                                            )}
                                        </Field>
                                        <OnChange name="prescriberPhoneThree">
                                            {(value, previous) => {
                                                if (numberValidator(value)) {
                                                    this.props.questionAnswer(
                                                        "prescriberPhoneThree",
                                                        value
                                                    );
                                                }
                                            }}
                                        </OnChange>
                                    </div>
                                    <Field
                                        name="prescriberPhoneNumber"
                                        component="input"
                                        defaultValue={
                                            prescriberPhoneOne +
                                            prescriberPhoneTwo +
                                            prescriberPhoneThree
                                        }
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    {...input}
                                                    type="text"
                                                    className="form-control full-width-input hidden-field"
                                                    tabindex="-1"
                                                />
                                            </Fragment>
                                        )}
                                    </Field>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm">
                                <Field
                                    name="planNumber"
                                    label="Plan number"
                                    component={textField}
                                />
                            </div>
                            <div className="col-sm">
                                <Field
                                    name="groupNumber"
                                    label="Group number"
                                    component={textField}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm">
                                <Field
                                    name="pcnumber"
                                    label="PCN number"
                                    component={textField}
                                />
                            </div>
                            <div className="col-sm">
                                <Field
                                    name="binNumber"
                                    label="BIN number"
                                    component={textField}
                                />
                            </div>
                            <div class="col-sm">
                                <Field
                                    name="medicareBeneficiaryID"
                                    label="Medicare beneficiary ID"
                                    component={textField}
                                />
                            </div>
                        </div>
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const { currentStep, questionOptions } = state;
    return { currentStep: currentStep, questionOptions: questionOptions };
};
export default connect(mapStateToProps, actions)(Step2);
